import type { DraggableAttributes } from "@dnd-kit/core";
import type { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { GripVertical } from "lucide-react";
import type { Ref } from "react";
import { useTranslation } from "react-i18next";

export interface TableDragHandleCellProps {
  attributes: DraggableAttributes;
  listeners: SyntheticListenerMap | undefined;
  ref?: Ref<HTMLButtonElement>;
}

export const TableDragHandleCell = ({ attributes, listeners, ref }: TableDragHandleCellProps) => {
  const { t } = useTranslation();

  return (
    <div data-slot="table-drag-handle-cell" className="flex min-w-0 items-center justify-center overflow-hidden">
      <button
        ref={ref}
        type="button"
        aria-label={t("Reorder row")}
        className="cursor-grab touch-none rounded-sm text-muted-foreground outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring active:cursor-grabbing"
        {...attributes}
        {...listeners}
      >
        <GripVertical className="size-4" />
      </button>
    </div>
  );
};
